//  Name: navbar
import Tooltip from 'vue-bulma-tooltip'
import { mapGetters, mapActions } from 'vuex'
import { LOGO, BLOG_URL } from '@/config'

export default {
  data () {
    return {
      logo: LOGO,
      blog: BLOG_URL
    }
  },
  props: {
    show: Boolean
  },
  computed: mapGetters({
    sidebar: 'sidebar',
    device: 'device'
  }),
  methods: {
    ...mapActions([
      'toggleSidebar'
    ]),
    logout () {
    }
  },
  components: {
    Tooltip
  }
}



// WEBPACK FOOTER //
// ./src/components/navbar/script.js